import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav, Collapse } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { StateContext } from "../../../utils/context";
import { useTranslation } from "react-i18next";

const mapStateToProps = state => ({
	...state
});


const SidebarItem = ({activeRoute, path, name, pro, icon, keyName} ) => {
	const { t } = useTranslation();

	// const {currentUser} = React.useContext(StateContext);
	// const {distribution, promotions} = currentUser;
	// if (!distribution && (name === "Releases" || name === "Artists" || name === "Trends")) {
	// 	return false;
	// }
	// if (!promotions && (name === "Promotions" || name === "Recipients" || name === "Lists" || name === "Feature Request")) {
	// 	return false;
	// }

	return (
		<li className={activeRoute() + (pro ? ' active active-pro' : '') + ' sidebar-item'} key={keyName + name}>
			<NavLink to={path} className="sidebar-link" activeClassName="active">
				<i className={icon} />
				<span className="hide-menu">{t(`${name}`)}</span>
			</NavLink>
		</li>
	)
}

const Spotify = ({keyName, icon, path, name}) => {
	const {currentUser} = React.useContext(StateContext);
	const {promotions} = currentUser;
	const { t } = useTranslation();


	if (!promotions && (name === "Spotify Playlist Pitch")) {
		return false;
	}
	return (
		<li className="sidebar-item" key={keyName}>
			<a className="sidebar-link" rel="noopener noreferrer" target="_blank" href={path}>
			<i className={icon}></i>
			<span className="hide-menu">{t(`${name}`)}</span>
			</a>
		</li>
	);
}


const  Sidebar = ({routes, settings, pathname}) => {
	const [_state, setState] = useState({
		authentication: false,
		uicomponents: false,
		samplepages: false,
		dashboardpages: false,
		iconsPages: false,
		formlayoutPages: false,
		formpickerPages: false,
	});

	const { t } = useTranslation();

	/*--------------------------------------------------------------------------------*/
	/*To Expand SITE_LOGO With Sidebar-Menu on Hover                                  */
	/*--------------------------------------------------------------------------------*/
	const expandLogo = () => {
		document.getElementById("logobg").classList.toggle("expand-logo");
	}
	/*--------------------------------------------------------------------------------*/
	/*Verifies if routeName is the one active (in browser input)                      */
	/*--------------------------------------------------------------------------------*/
	const activeRoute = (routeName) => {
		let isActive = pathname.indexOf(routeName) > -1 ? 'selected' : ''; 
		return isActive;
	}


	useEffect(() => {
		setState({
			authentication: activeRoute("/authentication") !== "" ? true : false,
			uicomponents: activeRoute("/ui-components") !== "" ? true : false,
			samplepages: activeRoute("/sample-pages") !== "" ? true : false,
			dashboardpages: activeRoute("/dahboards") !== "" ? true : false,
			iconsPages: activeRoute("/icons") !== "" ? true : false,
			formlayoutPages: activeRoute("/form-layouts") !== "" ? true : false,
			formpickerPages: activeRoute("/form-pickers") !== "" ? true : false,
		});
	}, [pathname]);


	return (
		// <aside className="left-sidebar" id="sidebarbg" data-sidebarbg={settings.activeSidebarBg} onMouseEnter={expandLogo} onMouseLeave={expandLogo}>

			<aside className="left-sidebar" id="sidebarbg" data-sidebarbg={settings.activeSidebarBg} >	
				<div className="scroll-sidebar">
					<PerfectScrollbar className="sidebar-nav">
						{/*--------------------------------------------------------------------------------*/}
						{/* Sidebar Menus will go here                                                */}
						{/*--------------------------------------------------------------------------------*/}
						<Nav id="sidebarnav">
							{routes.map((prop, key) => {
								if (prop.redirect) {
									return null;
								}
								else if (prop.invisible)  {
									return null;
								}
								else if (prop.navlabel) {
									return (
										<li className="nav-small-cap" key={key}>
											<i className={prop.icon}></i>
											<span className="hide-menu">{t(`${prop.name}`)}</span>
										</li>
									);
								}
								else if (prop.link) {
									return <Spotify 
												key={key}
												keyName={key}
												icon={prop.icon}
												path={prop.path}
												name={prop.name}
											/>
								} else if (prop.invisible) {
									return(
										<li className="invisible" key={key}>
										<NavLink to={prop.path} className="sidebar-link" activeClassName="active">
											<i className={prop.icon} />
											<span className="hide-menu">{t(`${prop.name}`)}</span>
										</NavLink>
									</li>
								);
									
								}
								else if (prop.collapse) {
									let firstdd = {};
									firstdd[prop["state"]] = !_state[prop.state];
									return (
										/*--------------------------------------------------------------------------------*/
										/* Menus wiil be goes here                                                        */
										/*--------------------------------------------------------------------------------*/
										<li className={activeRoute(prop.path) + ' sidebar-item'} key={key}>
											<span data-toggle="collapse" className="sidebar-link has-arrow" aria-expanded={_state[prop.state]} onClick={() => setState(firstdd)} >
												<i className={prop.icon} />
												<span className="hide-menu">{t(`${prop.name}`)}</span>
											</span>
											{/*--------------------------------------------------------------------------------*/}
											{/* Sub-Menus wiil be goes here                                                    */}
											{/*--------------------------------------------------------------------------------*/}
											<Collapse isOpen={_state[prop.state]}>
												<ul className="first-level">
													{prop.child.map((prop, key) => {
														if (prop.redirect) return null;
														
														if (prop.collapse) {
															let seconddd = {};
															seconddd[prop["state"]] = !_state[prop.state];
															return (
																<li className={activeRoute(prop.path) + ' sidebar-item'} key={key} >
																	<span data-toggle="collapse" className="sidebar-link has-arrow" aria-expanded={_state[prop.state]} onClick={() => setState(seconddd)} >
																		<i className={prop.icon} />
																		<span className="hide-menu">{t(`${prop.name}`)}</span>
																	</span>
																	{/*--------------------------------------------------------------------------------*/}
																	{/* Sub-Menus wiil be goes here                                                    */}
																	{/*--------------------------------------------------------------------------------*/}
																	<Collapse isOpen={_state[prop.state]}>
																		<ul className="second-level">
																			{prop.subchild.map((prop, key) => {
																				if (prop.redirect) return null;
																				return (
																					<li className={activeRoute(prop.path) + ' sidebar-item'} key={key} >
																						<NavLink to={prop.path} activeClassName="active" className="sidebar-link">
																							<i className={prop.icon} />
																							<span className="hide-menu">{t(`${prop.name}`)}</span>
																						</NavLink>
																					</li>
																				);
																			})}
																		</ul>
																	</Collapse>
																</li>
															);
														}
														return (
															/*--------------------------------------------------------------------------------*/
															/* Adding Sidebar Item                                                            */
															/*--------------------------------------------------------------------------------*/
															<li className={activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'} key={key}>
																<NavLink to={prop.path} className="sidebar-link" activeClassName="active">
																	<i className={prop.icon} />
																	<span className="hide-menu">{t(`${prop.name}`)}</span>
																</NavLink>
															</li>
														);
													})}
												</ul>
											</Collapse>
										</li>
									);
								}
								else {
									return (
										/*--------------------------------------------------------------------------------*/
										/* Adding Sidebar Item                                                            */
										/*--------------------------------------------------------------------------------*/
										<SidebarItem
											path={prop.path}
											name={prop.name}
											pro={prop.pro}
											icon={prop.icon}
											keyName={key}
											key={key+ prop.name}
											activeRoute={() => activeRoute(prop.path)}
										/>								
									);
								}
							})}
						</Nav>
					</PerfectScrollbar>
				</div>
			</aside>
	);
}
export default connect(mapStateToProps)(Sidebar);
